import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Award = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.999c0 1.902.765 3.627 2 4.89V21a.998.998 0 001.447.895L12 20.118l3.553 1.776a.992.992 0 00.972-.043c.295-.183.475-.504.475-.851v-7.11a6.976 6.976 0 002-4.891C19 5.14 15.86 2 12 2S5 5.14 5 8.999zm7.447 9.106a1 1 0 00-.895 0L9 19.382v-4.067c.911.434 1.926.685 3 .685s2.089-.25 3-.685v4.066l-2.553-1.276zM12 4c2.756 0 5 2.242 5 4.999A5.006 5.006 0 0112 14c-2.757 0-5-2.243-5-5.001A5.005 5.005 0 0112 4z"
  }));
});
Award.displayName = 'Award';
export var AwardDimensions = {
  height: 24,
  width: 24
};